/* Form Haircare — interactions: sticky buy + ajax add-to-cart + cart badge */
(function () {
  // Sticky buy visibility (appears past first viewport)
  var sticky = document.querySelector('.fh-sticky');
  if (sticky) {
    var onScroll = function () {
      if (window.scrollY > window.innerHeight * 0.9) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function getCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }
  function setBadges(n) {
    document.querySelectorAll('[data-fh-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  getCartCount().then(function (n) { if (n != null) setBadges(n); });

  // Ajax add-to-cart for any form.fh-atc
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('fh-atc')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function () { return getCartCount(); })
      .then(function (n) {
        if (n != null) setBadges(n);
        // Broadcast events modern Shopify themes (incl. Horizon/Dawn) listen for
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        // Open Horizon's cart drawer if it exposes a trigger element
        var drawerTrigger = document.querySelector('[data-cart-drawer-toggle], [data-cart-toggle]');
        if (drawerTrigger) drawerTrigger.dispatchEvent(new Event('click', { bubbles: true }));
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) btn.disabled = false; });
  }, false);
})();